var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"white pt-2 pl-5 pr-5",attrs:{"fluid":""}},[_c('AbacusImport'),_c('SilentsoftImport'),_c('DossierImport'),_c('ConstructionProjectsImport'),_c('ImmoSparrowImport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }